import View from './view';
export const VisuallyImpairedButton = View;
